import React, { useRef, useState } from "react";
import { Box, TextField } from "@mui/material";
import Image from "next/image";
import Calender_Icon_Grey from "public/assets/images/Calender_Icon_Grey.png";

interface DatePickerProps {
  placeholder: string;
  style?: React.CSSProperties;
  value: string;
  setDate: (date: string) => void;
  error?: string; // Updated to expect a string error
}

const DatePicker: React.FC<DatePickerProps> = ({ placeholder, style, value, setDate, error }) => {
  const fromDateInput = useRef<HTMLInputElement>(null);
  const [hideCustomCalendar, setHideCustomCalendar] = useState<boolean>(true);

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <TextField
        inputRef={fromDateInput}
        placeholder={placeholder}
        label={placeholder}
        fullWidth
        margin="normal"
        value={value}
        onFocus={(e: any) => {
          e.target.type = "date";
          setHideCustomCalendar(false);
        }}
        onBlur={(e: any) => {
          if (!e.target.value) e.target.type = "text";
          setHideCustomCalendar(true);
        }}
        onChange={(e) => setDate(e.target.value)}
        
        sx={{ ...style }}
        error={!!error} // Display error state
        helperText={error} // Show error message
      />
    </Box>
  );
};

export default DatePicker;
